/// <amd-module name="Build/DesignerExtensions/YamlAssistant/Sources/SnippetListSource" />
import { YamlSnippet } from "Pipelines/Common/Library/Contracts/DataProvider";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

const contributionID = "ms.vss-build-web.yaml-assistant-data-provider";

export class SnippetListSource {
    private _snippetList: YamlSnippet[];
    /**
     * Snippets that we don't show, typically because they have a newest version.
     */
    private _hiddenSnippets: YamlSnippet[] = [];
    private _contributionService: IVssContributionService;

    public constructor(pageContext: IVssPageContext) {
        this._contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    }

    public getSnippets = (): YamlSnippet[] => {
        if (this._snippetList) {
            return this._snippetList;
        }

        this._snippetList = this._contributionService.getData<YamlSnippet[]>(contributionID) || [];

        return this._snippetList;
    }

    public async getSnippet(taskName: string, taskVersion: string): Promise<YamlSnippet | undefined> {
        // Try to find snippet in local list. If not present, search in the server (needed if version is old)
        const allSnippets = [...this.getSnippets(), ...this._hiddenSnippets];
        const matchingSnippet = allSnippets.find(snippet => 
            (snippet.version.major.toFixed() === taskVersion) &&
            (snippet.name === taskName||
            (snippet.contributionIdentifier && `${snippet.contributionIdentifier}.${snippet.name}` === taskName)));

        if (matchingSnippet) {
            return matchingSnippet;
        }

        const fetchedSnippet = await this._contributionService.getDataAsync<YamlSnippet>(contributionID, { taskName, taskVersion });
        if (fetchedSnippet) {
            this._hiddenSnippets.push(fetchedSnippet);
        }

        return fetchedSnippet;
    }
}
